export default __webpack_public_path__ + "static/media/testSeriesIcon.a9a3ce97.svg";